import type { ClientArea } from './types';
import { area as records } from './records';
import { area as record } from './record';
import { area as deals } from './deals';
import { area as mail } from './mail';
import { area as gmail } from './gmail';
import { area as admin } from './admin';
import { area as backups } from './backups';
import { area as home } from './home';
import { area as finder } from './finder';

/** Every product area of the web app, mirroring the server's list in src/server/areas.ts. */
export const areas: ClientArea[] = [records, record, deals, gmail, mail, admin, backups, home, finder];

let done = false;

/** Registers every area's parts. One area failing to set up leaves the others working. */
export function setupAreas(): void {
  if (done) return;
  done = true;
  for (const area of areas) {
    try {
      area.setup();
    } catch (err) {
      console.error(`[areas] ${area.name} failed to set up`, err);
    }
  }
}
